import { Box, Button, Text, useMediaQuery } from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";

export default function PerusahaanCard({ nama, kecamatan, image, id }) {
  const [mobile] = useMediaQuery("(max-width: 600px)");
  return (
    <Box borderRadius="10px" border="1px solid #E0E0E0">
      <img
        src={image}
        alt={nama}
        style={{
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
          width: "100%",
        }}
      />
      <Box p="4">
        <Text fontSize={mobile ? "14" : "20px"} fontWeight="500">
          {nama}
        </Text>
        <Text
          pt="1"
          pb="3"
          fontSize={mobile ? "12" : "16"}
          fontWeight="400"
          color="#B9B9B9"
        >
          {kecamatan}
        </Text>
        <Link to={"/perusahaan/" + id}>
          <Button
            variant="outline"
            width="full"
            colorScheme="blue"
            fontSize={mobile && "12"}
          >
            Lihat Toko
          </Button>
        </Link>
      </Box>
    </Box>
  );
}
